<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2024-12-24 10:44:05
 * @Description: 输入框组件
-->
<template>
  <el-time-picker
    is-range
    size="small"
    v-model="selectedValue"
    range-separator="至"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    placeholder="选择时间范围"
    :picker-options="pickerOptions"
    :value-format="valueFormat"
    :format="format"
    @change="handelChange"
  >
  </el-time-picker>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsTimePicker',
  componentName: 'LsTimePicker',
  mixins: [mixin],
  props: {
    defaultTime: {
      type: Array,
      default: [new Date, new Date],
    },
    pickerOptions: {
      type: Object,
      default: () => {}
    },
    valueFormat: {
      type: [String, Object],
      default: null
    },
    format: {
      type: [String, Object],
      default: 'HH:mm:ss'
    }
  },
  data () {
    return {
      selectedValue: null
    }
  },
  watch: {
    defaultTime(val) {
      this.selectedValue = val
    }
  },
  methods: {
    handelChange(data) {
      this.$emit('change', data)
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>